import React from "react";

function N() {
  return (
    <div>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto magnam eos
      pariatur ab, eius vel odit, aut quaerat porro fuga quis nobis amet maxime,
      eum atque reprehenderit repellat totam quisquam.
    </div>
  );
}

export default N;
